import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Tooltip } from 'ui-components/components/tooltip';
import { TooltipContent } from 'ui-components/components/tooltip/tooltip-content';
import { emptyArray } from 'ui-components/default-props/empty';

const CHARACTERS_TO_TRUNCATE_TO = 6;

const DrawerBatchTitle = ({ batchNames = emptyArray }) => {
  const batchTranslation = <FormattedMessage defaultMessage='Batch' description='orders.drawer.batch' id='D8hKDC' />;
  if (batchNames.length === 0 || (batchNames.length === 1 && !batchNames[0])) {
    return batchTranslation;
  }

  if (batchNames.length >= 2) {
    return (
      <span>
        {batchTranslation}
        &nbsp;
        <span>
          <FormattedMessage defaultMessage='(Multiple)' description='orders.drawer.multiple' id='AN4erT' />
        </span>
      </span>
    );
  }

  const batchName = batchNames[0];
  if (batchName.length <= CHARACTERS_TO_TRUNCATE_TO) {
    return (
      <span>
        {batchTranslation}
        &nbsp;
        <span>{batchName}</span>
      </span>
    );
  }

  return (
    <Tooltip>
      <span>
        {batchTranslation}
        &nbsp;
        <span>
          {batchName.substr(0, 5)}
          &hellip;
        </span>
      </span>
      <TooltipContent>{batchName}</TooltipContent>
    </Tooltip>
  );
};

DrawerBatchTitle.propTypes = {
  batchNames: PropTypes.arrayOf(PropTypes.string),
};

export default DrawerBatchTitle;
